import FilteringTable from './FilteringTable'

export default FilteringTable
